






















import Vue from "vue";
import chatMessage from "./chatMessage.vue";
import QuickReplies from "./QuickReplies.vue";
import DetictingMobile from "@/mixins/DetictingMobile";
import { PayloadContent } from "@tactful/sdk";
import { QuickReply } from "@/utilities";
const chatBody = Vue.extend({
    props: [
        "messages",
        "isFullScreen",
        "disconnected",
        "getLastTenMessages",
        "attachmentsFiles",
        "selectedLang",
        "showTypingIndicator",
    ],
    mixins: [DetictingMobile],
    components: {
        chatMessage,
        QuickReplies
    },
    data() {
        return {
            urlRegex: /(?:https?:\/\/|www\.)[^\s<]+/gi,
            aTagRegex: /<a\s+[^>]*href\s*=\s*["'][^"']*["'][^>]*>/i,
            emailRegex: /(?:[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x21\x23-\x5b]|\\[\x7f])*")@(?:(?:[\w](?:[\w]*[\w])?\.)+[\w](?:[\w]*[\w])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[\w]*[\w]:(?:[\x21-\x5a]|\\[\x7f])+)\])/
        };
    },
    computed: {
        quickReplies() {
            if (!this.messages?.length) return [];
            const lastMessage = this.messages[this.messages.length - 1] || {};
            return lastMessage?.quick_replies || [];
        }
    },
    mounted() {
        if (this.isMobile()) {
            window.addEventListener("resize", this.handleResizeEvent);
        }
    },
    beforeDestroy() {
        window.removeEventListener("resize", this.handleResizeEvent);
    },
    watch: {
        messages: function () {
            this.$nextTick(() => {
                this.scrollToTheEnd();
            });
        },
        '$route'(to, from) {
            if (from.name != 'webChat') {
                this.$nextTick(() => {
                    this.scrollToTheEnd();
                });
            }
        },
        attachmentsFiles: {
            handler() {
                this.$nextTick(() => {
                    this.scrollToTheEnd();
                });
            },
            deep: true
        },
        showTypingIndicator(val) {
            if (val) {
                this.$nextTick(() => {
                    this.scrollToTheEnd();
                });
            }
        }
    },
    methods: {
        handleResizeEvent() {
            this.$nextTick(() => {
                this.scrollToTheEnd();
            });
        },
        sendQuickReply(quickReply: QuickReply) {
            this.$emit("sendQuickReply", quickReply);
        },
        onPostback(payload: PayloadContent, title: string) {
            this.$emit("onPostback", payload, title);
        },
        scrollToTheEnd() {
            if (!this.$el) return;
            this.$el.scroll({ top: this.$el.scrollHeight, behavior: 'smooth' });
        },
    }
});
export default chatBody;
